<template lang="pug">
  svg.logo-image(viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg")
    clipPath(id="imgClip")
      rect(width="100" height="100" :style="`transform: rotate(45deg) scale(2) translateY(${100-100*progress}%)`")
    image(:xlink:href="logoIcon" :width="w" :height="h" :x="x" :y="y" clip-path="url(#imgClip)")
</template>

<script>
import logoIcon from 'assets/logo-deco3.png'
import gsap from 'gsap'
export default {
  name: 'LogoImage',
  props: {},
  data() {
    return {
      progress: 1,
      logoIcon: logoIcon,
      w: 100,
      h: 100,
      x: 0,
      y: 0,
      //w: 122,
      //h: 122,
      //x: -7,
      //y: -3,
    }
  },
  mounted() {},
  methods: {
    animeIn(dur) {
      //return gsap.timeline().to(this, { progress: 1, duration: dur })
      return gsap.timeline().to(this.$el, { opacity: 1, duration: dur })
    },
  },
}
</script>

<style scoped lang="sass">
.logo-image
  opacity: 0
  width: 100%
  height: 100%
rect
  transform-origin: center
  transform: rotate(45deg) scale(2)
</style>
